(function(){
  var root=document.getElementById('elevo-advertorial');if(!root||root.__elevo)return;root.__elevo=true;
  /* Product URL comes from the single Liquid config value (data-product-url). */
  var CFG={productUrl:root.getAttribute('data-product-url'),
    trackingParams:['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','campaign_id','ad_id']};
  window.ELEVO_CONFIG=CFG;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- purchase links keep campaign parameters ---- */
  try{
    var url=new URL(CFG.productUrl,location.href),cur=new URLSearchParams(location.search);
    CFG.trackingParams.forEach(function(k){var v=cur.get(k);if(v&&!url.searchParams.has(k))url.searchParams.set(k,v.slice(0,200));});
    root.querySelectorAll('[data-elevo-buy]').forEach(function(a){a.href=url.toString();});
  }catch(e){}

  /* ---- smooth internal scroll ---- */
  function go(id){var t=document.querySelector(id);if(t)t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});return !!t;}
  root.addEventListener('click',function(e){var a=e.target.closest('a[data-elevo-scroll]');if(!a)return;var id=a.getAttribute('href');if(id&&id.charAt(0)==='#'&&go(id))e.preventDefault();});

  /* ---- motion (hidden states only exist after .elevo-js-ready) ---- */
  if('IntersectionObserver' in window&&!reduce){
    root.classList.add('elevo-js-ready');
    requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('elevo-hero-in');});});
    var mk=function(th){var o=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-visible');o.unobserve(en.target);}});},{threshold:th,rootMargin:'0px 0px -10% 0px'});return o;};
    var big=mk(.15),small=mk(.3);
    root.querySelectorAll('[data-elevo-reveal]').forEach(function(el){var k=el.getAttribute('data-elevo-reveal');((/mask|settle|seq|product/).test(k)?big:small).observe(el);});
    setTimeout(function(){root.querySelectorAll('[data-elevo-reveal]:not(.is-visible)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0)el.classList.add('is-visible');});},2600);
    var px=root.querySelector('[data-elevo-parallax]');
    if(px&&innerWidth>=1024){
      var on=false,tick=false;
      var step=function(){tick=false;var r=px.parentNode.getBoundingClientRect();var p=(r.top+r.height/2-innerHeight/2)/innerHeight;px.style.transform='translate3d(0,'+(Math.max(-1,Math.min(1,p))*-4)+'%,0)';};
      var onScroll=function(){if(!tick){tick=true;requestAnimationFrame(step);}};
      new IntersectionObserver(function(es){var v=es[0].isIntersecting;if(v&&!on){on=true;addEventListener('scroll',onScroll,{passive:true});step();}else if(!v&&on){on=false;removeEventListener('scroll',onScroll);}}).observe(px.parentNode);
    }
  }

  /* ---- TRUST count-up (static 10,000 without JS / reduced motion) ---- */
  var cnt=root.querySelector('[data-elevo-count]');
  if(cnt&&'IntersectionObserver' in window&&!reduce){
    var to=+cnt.getAttribute('data-elevo-count'),fmt=function(n){return n.toLocaleString('en-US');};
    var co=new IntersectionObserver(function(es){if(!es[0].isIntersecting)return;co.disconnect();var t0=performance.now(),d=1800;
      (function f(t){var p=Math.min(1,(t-t0)/d),e=1-Math.pow(1-p,4);cnt.textContent=fmt(Math.round(to*e));if(p<1)requestAnimationFrame(f);})(t0);},{threshold:.35});
    cnt.textContent='0';co.observe(cnt);
  }

  /* ---- HOW TO pinned stage ---- */
  var stage=root.querySelector('.elevo-how__stage');
  if(stage&&'IntersectionObserver' in window){
    if(!root.classList.contains('elevo-js-ready'))root.classList.add('elevo-js-ready','elevo-hero-in');
    var steps=root.querySelectorAll('.elevo-how__step'),imgs=stage.querySelectorAll('img');
    var setStep=function(n){steps.forEach(function(s){s.classList.toggle('is-active',s.getAttribute('data-step')===n);});imgs.forEach(function(i){i.classList.toggle('is-active',i.getAttribute('data-step-img')===n);});};
    var so=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting)setStep(en.target.getAttribute('data-step'));});},{rootMargin:'-45% 0px -45% 0px',threshold:0});
    steps.forEach(function(s){so.observe(s);});
  }

  /* ---- height selector (radio group) ---- */
  var hs=root.querySelectorAll('.elevo-hsel__opt'),hOut=root.querySelector('[data-hsel-h]'),cOut=root.querySelector('[data-hsel-copy]');
  function pickH(btn){hs.forEach(function(b){var on=b===btn;b.classList.toggle('is-on',on);b.setAttribute('aria-checked',on?'true':'false');b.tabIndex=on?0:-1;});
    if(hOut)hOut.textContent=btn.getAttribute('data-h')+'cm';if(cOut)cOut.textContent=btn.getAttribute('data-copy');}
  hs.forEach(function(b,i){b.tabIndex=b.classList.contains('is-on')?0:-1;
    b.addEventListener('click',function(){pickH(b);});
    b.addEventListener('keydown',function(e){var d=(e.key==='ArrowRight'||e.key==='ArrowDown')?1:(e.key==='ArrowLeft'||e.key==='ArrowUp')?-1:0;if(!d)return;e.preventDefault();var n=hs[(i+d+hs.length)%hs.length];pickH(n);n.focus();});
  });

  /* ---- FAQ accordion (all open when JS is off) ---- */
  root.querySelectorAll('.elevo-acc__q button').forEach(function(b){
    var p=document.getElementById(b.getAttribute('aria-controls'));if(!p)return;
    b.setAttribute('aria-expanded','false');p.hidden=true;
    b.addEventListener('click',function(){var o=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',o?'false':'true');p.hidden=o;});
  });

  /* ---- real footage: play when visible, pause offscreen ---- */
  var vid=root.querySelector('[data-elevo-video]'),vt=root.querySelector('[data-elevo-video-toggle]'),userPaused=false;
  if(vid){
    vid.muted=true;
    var setBtn=function(){if(vt)vt.setAttribute('aria-pressed',vid.paused?'false':'true');};
    vid.addEventListener('play',setBtn);vid.addEventListener('pause',setBtn);
    if(vt)vt.addEventListener('click',function(){if(vid.paused){userPaused=false;vid.play().catch(function(){vid.controls=true;});}else{userPaused=true;vid.pause();}});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){var en=es[0];if(en.isIntersecting&&en.intersectionRatio>=.5){if(!userPaused&&!reduce)vid.play().catch(function(){vid.controls=true;});}else if(!vid.paused){vid.pause();}},{threshold:[0,.5]}).observe(vid);
    }
  }

  /* ---- mobile sticky CTA: after ANSWER, hidden over OFFER and at the end ---- */
  var sticky=document.getElementById('elevo-sticky');
  if(sticky){
    document.body.appendChild(sticky);sticky.hidden=false;
    var btn=sticky.querySelector('[data-elevo-sticky-btn]');
    btn.addEventListener('click',function(e){if(go('#elevo-offer'))e.preventDefault();});
    var answer=document.getElementById('elevo-answer'),offer=document.getElementById('elevo-offer'),fin=document.getElementById('elevo-final');
    var reached=false,inOffer=false,atEnd=false;
    var upd=function(){var on=reached&&!inOffer&&!atEnd;sticky.classList.toggle('is-on',on);sticky.setAttribute('aria-hidden',on?'false':'true');btn.tabIndex=on?0:-1;};
    if('IntersectionObserver' in window){
      if(answer)new IntersectionObserver(function(es){var en=es[0];reached=en.isIntersecting||en.boundingClientRect.top<0;upd();},{threshold:0}).observe(answer);
      if(offer)new IntersectionObserver(function(es){inOffer=es[0].isIntersecting;upd();},{threshold:0,rootMargin:'-20% 0px -20% 0px'}).observe(offer);
      var endIn=false,footIn=false;
      if(fin)new IntersectionObserver(function(es){endIn=es[0].isIntersecting&&es[0].intersectionRatio>.35;atEnd=endIn||footIn;upd();},{threshold:[0,.35,.6]}).observe(fin);
      var foot=document.querySelector('footer, .shopify-section-group-footer-group');
      if(foot)new IntersectionObserver(function(es){footIn=es[0].isIntersecting;atEnd=endIn||footIn;upd();},{threshold:0}).observe(foot);
    }
    upd();
  }
})();
